import React, { Component } from 'react';
import Menu from "./../Menu/Menu";
import Splash from "./../Splash/Splash";
import About from "./../About/About";
import WeWork from "./../WeWork/WeWork";
import WorkWithUs from "./../WorkWithUs/WorkWithUs";
import Services from "../Services/Services";

class LandingHome extends Component {
    render() {
        return (
            <div className="App">
                <Splash/>
                <About/>
                <WeWork/>
                <WorkWithUs/>
                <Services changeService={this.props.changeService}/>
            </div>
        );
    }
}

export default LandingHome;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/LandingHome/LandingHome.js